<style lang="less" scoped>
@import "../../../../stylesheet/variable.less";
.order-invoice-detail {
  background-color: #fff;
  font-size: 13px;
  color: #2e2f30;
  padding-top: 44px;
  .status {
    position: relative;
    height: 48px;
    line-height: 48px;
    padding: 0 15px;
    &:after {
      .setBottomLine();
    }
  }
  .container {
    padding: 15px 0 15px 15px;
    .line {
      margin-bottom: 8px;
      .btn {
        display: inline-block;
        position: relative;
        color: #797d82;
        text-align: center;
        padding: 2px 6px;
        margin-left: 15px;
        font-size: 11px;
        &:after {
          .setBorderLine(#bdc0c5);
        }
      }
    }
    .line:last-child {
      margin-bottom: 0px;
    }
  }
  .email-box-wrapper {
    position: absolute;
    z-index: 2009;
    .box-modal {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      background: #000;
    }
    .email-box {
      position: fixed;
      top: 50%;
      left: 50%;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
      background-color: #fff;
      width: 85%;
      border-radius: 3px;
      font-size: 16px;
      -webkit-user-select: none;
      overflow: hidden;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      .email-content {
        padding: 25px 20px 38px 20px;
        color: #191a1b;
        .content {
          font-size: 17px;
          text-align: center;
        }
        .input {
          margin-top: 38px;
          padding-bottom: 15px;
          position: relative;
          &:after {
            .setBottomLine();
          }
          input {
            width: 100%;
            font-size: 15px;
            border: none;
            text-align: left;
            height: 21px;
            line-height: 21px;
          }
        }
        .success {
          text-align: center;
          padding-top: 40px;
          padding-bottom: 62px;
          font-size: 15px;
        }
      }
      .email-btn {
        display: flex;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
        text-align: center;
        position: relative;
        &:after {
          .setTopLine();
        }
        .btn {
          line-height: 35px;
          display: block;
          background-color: #fff;
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          margin: 0;
          width: 50%;
          line-height: 48px;
        }
        .cancel {
          position: relative;
          &:after {
            .setRightLine();
          }
        }
        .confirm {
          color: #c63036;
        }
      }
    }
  }
}
</style>
<template>
  <div class="order-invoice-detail">
    <my-header showBack>
      <div slot="title">发票信息</div>
      <!-- <div slot="right" color="#c03131" class="add-button" @click="showTips">
        <icon style="font-size: 25px;">shangpinjiesuan-wangjimima</icon>
      </div> -->
    </my-header>
    <div class="status">发票状态：{{ invoiceStatus }}</div>
    <div class="container">
      <div class="line">
        发票类型：电子增值税普通发票
        <span
          class="btn"
          @click="checkInvoice"
          v-if="invoiceDetail.invoiceStatus === 2"
          >查看发票</span
        >
      </div>
      <div class="line">发票抬头：{{ invoiceDetail.buyerName }}</div>
      <div class="line" v-if="invoiceDetail.taxNum">
        发票税号：{{ invoiceDetail.taxNum }}
      </div>
      <div class="line">开票流水号：{{ invoiceDetail.invoiceSeq }}</div>
      <div class="line" v-if="invoiceDetail.createdAt">
        开票时间：{{ invoiceDetail.createdAt | time_second }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MessageBox, Toast } from "mint-ui";
import _ from "underscore";
import { setTimeout } from "timers";
import myHeader from "../../../components/header.vue";
export default {
  data() {
    return {
      email: "",
      sendSuccess: false
    };
  },
  components: {
    myHeader
  },
  computed: {
    orderId: context => {
      return context.$route.params.orderId;
    },
    ...mapState({
      invoiceDetail: state => state.order.invoiceDetail
    }),
    invoiceStatus: context => {
      if (_.isEmpty(context.invoiceDetail)) {
        return "未开票";
      }
      return context.invoiceDetail.invoiceStatus === 1
        ? "开票中"
        : context.invoiceDetail.invoiceStatus === 2
        ? "已开票"
        : context.invoiceDetail.invoiceStatus === 3
        ? "开票失败"
        : "发票已冲红";
    }
  },
  mounted() {
    this.getOrderInvoiceDetail(this.orderId);
  },
  methods: {
    ...mapActions(["getOrderInvoiceDetail", "sendOrderInvoiceEmail"]),
    checkInvoice() {
      window.open(this.invoiceDetail.url, "_blank");
    }
  }
};
</script>
